<template>
    <component :is="tag" v-bind="{ loading, ...$attrs }" @click="excel"> <slot /> </component>
</template>

<script>
import XLSX from "xlsx";
import { RECRUITMENT_KANBAN_FIELDS } from "@/assets/variables";
import dayjs from "dayjs";

export default {
    props: {
        tag: { type: String, default: "v-btn" },
        selected: { type: Array, default: () => [] },
        fileName: { type: String, default: "지원서 목록" },
    },
    data: () => ({
        loading: false,
    }),
    methods: {
        async excel() {
            if (this.loading) return;
            else this.loading = true;

            try {
                if (!this.selected?.length) throw new Error("출력할 항목이 없습니다");

                let rows = this.selected.map((application) => {
                    let address = [];

                    let { postcode, address1, address2 } = application?.resume?.personalInformation?.residence || {};

                    if (postcode) address.push(`[${postcode}]`);
                    address.push(address1, address2);
                    address = address.filter((item) => !!item).join(" ");

                    return {
                        상태: Object.values(RECRUITMENT_KANBAN_FIELDS).find(({ stage }) => stage == application.stage)?.text || "-",
                        이름: application?.resume?.personalInformation?.name || "-",
                        성별: application?.resume?.personalInformation?.genderText || "-",
                        나이: application?.resume?.personalInformation?.age || "-",
                        생년월일: application?.resume?.personalInformation?.bornAt?.toDate?.()?.split?.("-")?.join?.(".") || "-",
                        연락처: application?.resume?.personalInformation?.phone || "-",
                        이메일: application?.resume?.personalInformation?.email || "-",
                        거주지: address?.trim?.() || "-",
                    };
                });

                let dateTime = dayjs().format("YYYYMMDD_HHmmss");
                let workbook = new XLSX.utils.book_new();
                let worksheet = XLSX.utils.json_to_sheet(rows);

                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, `${this.fileName}-${dateTime}.xlsx`);
            } catch (error) {
                console.error(error);
                alert(error?.message);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
